export enum AvoirExterneStatutEnum {
  A_TRAITER = 'A_TRAITER',
  VALIDEE_AUTOMATIQUEMENT = 'VALIDEE_AUTOMATIQUEMENT',
  VALIDEE_MANUELLEMENT = 'VALIDEE_MANUELLEMENT',
  REFUSEE = 'REFUSEE',
  ABANDONNEE = 'ABANDONNEE',
  EXPORTE = 'EXPORTE',
  EXPORT_CEGID = 'EXPORT_CEGID'
}

export const AVOIR_EXTERNE_STATUT_LABELS: Record<AvoirExterneStatutEnum, string> = {
  [AvoirExterneStatutEnum.A_TRAITER]:               'À traiter',
  [AvoirExterneStatutEnum.VALIDEE_AUTOMATIQUEMENT]: 'Validée automatiquement',
  [AvoirExterneStatutEnum.VALIDEE_MANUELLEMENT]:    'Validée manuellement',
  [AvoirExterneStatutEnum.REFUSEE]:                 'Refusée',
  [AvoirExterneStatutEnum.ABANDONNEE]:              'Abandonnée',
  [AvoirExterneStatutEnum.EXPORTE]:                 'Exporté',
  [AvoirExterneStatutEnum.EXPORT_CEGID]:            'Exporté Cegid',
};
